import {Component, ViewChild, NgZone} from '@angular/core';
import {Nav, Platform, Events} from 'ionic-angular';

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {Network} from '@ionic-native/network';

import {UserService} from '../services/UserService';
import {NetInfoService} from '../services/NetInfoService';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'RaizPage';
  net_staus: boolean = true;
  menus: Array<{ name: string, icon: string, component: string }>;
  user: any;

  constructor(
    public zone: NgZone,
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public network: Network,
    public events: Events,
    private userService: UserService,
    private netInfoService: NetInfoService
  ) {

    this.netInfoService.set('status', 1);
    this.initializeApp();
  }


  initializeApp() {

    this.platform.ready().then(() => {


      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);


      this.network.onConnect().subscribe(() => {

        //this.events.publish('tareas:refesh');
        this.netInfoService.set('status', 1);
        //this.refreshMenu();
      });

      this.network.onDisconnect().subscribe(() => {
        this.netInfoService.set('status', 0);
        //this.refreshMenu();
      });


    });
  }


  goToPage(page) {
    this.nav.setRoot(page.component);
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts